const providersUS = [
	9, 350, 2, 337, 15, 283, 257, 10, 386, 531, 464, 1899, 1796, 8, 175, 1852, 1853, 1854, 1855, 2033, 2036, 2039, 2040,
	2042, 2044, 2045, 2047, 2048, 2049, 2050, 2055, 2056, 2057, 2058, 2059, 2060, 2061, 529, 2129, 196, 197, 199, 201,
	202, 204, 205, 262, 263, 287, 289, 290, 291, 293, 294, 295, 343, 528, 582, 583, 584, 597, 598, 600, 602, 688, 689,
	690, 1711, 1794, 1811, 1825, 1890, 1968, 2064, 2066, 2068, 2071, 2073, 2089, 2164, 2172, 2174, 2243, 2262, 2266,
	2273, 2274, 2275, 2296, 2314, 2315, 2316, 2317, 2318, 2319, 2320, 2321, 2322, 2323, 2324, 2325, 2326, 2327, 2328,
	2329, 2360, 2362, 2364, 2365, 2366, 2367, 2368, 2369, 2371, 2374, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2390,
	2392, 2393, 2394, 2395, 2396, 2398, 2399, 2400, 2401, 2402, 2403, 2404, 2405, 2406, 2407, 2408, 2413, 2414, 2415,
	2417, 2418, 2419, 2420, 2423, 2425, 2426, 2427, 2428, 2429, 2430, 2431, 2432, 2433, 2434, 2435, 2436, 2437, 2438,
	2439, 2440, 2441, 2442, 2443, 2444, 2445, 2446, 2448, 2449, 2450, 2451, 2452, 2453, 2454, 2455, 2457, 2458, 2459,
	2460, 2461, 2462, 2463, 2464, 2465, 2466, 2467, 2468, 2469, 2470, 2471, 2473, 2474, 2475, 2330, 677, 2078, 692,
	2239, 156, 148, 87, 2034, 1958, 318, 532, 251, 613, 2100, 80, 162, 526, 635, 1956, 399, 514, 179, 2120, 397, 1759,
	365, 151, 554, 438, 1975, 1978, 1957, 445, 258, 190, 2308, 444, 403, 520, 508, 1971, 569, 475, 60, 7, 332, 25, 579,
	701, 559, 432, 331, 366, 328, 211, 123, 1962, 1990, 3, 100, 2118, 417, 406, 503, 430, 155, 268, 315, 212, 368, 408,
	581, 2285, 191, 2135, 1793, 157, 284, 551, 2123, 568, 585, 34, 636, 427, 68, 1960, 562, 11, 1972, 264, 1964, 79,
	455, 575, 1976, 1953, 433, 487, 633, 1770, 209, 387, 2383, 538, 2077, 1945, 300, 1832, 638, 278, 344, 2117, 446,
	1948, 473, 1875, 411, 185, 1715, 439, 99, 486, 43, 634, 309, 143, 1771, 506, 361, 83, 555, 207, 412, 363, 2030, 413,
	507, 567, 73, 1860, 322, 422, 458, 457, 509, 546, 260, 1963, 192, 235, 188,
];

const providersGB = [
	9, 350, 2, 29, 337, 283, 529, 642, 1853, 2041, 2047, 2060, 677, 1875, 1796, 8, 175, 196, 197, 199, 201, 204, 205,
	287, 296, 582, 584, 595, 596, 597, 598, 599, 600, 602, 603, 604, 607, 688, 689, 690, 1710, 1744, 1745, 1746, 1747,
	1757, 1893, 1968, 2066, 2068, 2141, 2164, 2172, 2243, 2262, 2264, 2266, 2273, 2274, 2275, 2278, 2290, 2296, 2314,
	2316, 2317, 2321, 2323, 2324, 2325, 2361, 2362, 2390, 2392, 2406, 2420, 2426, 2428, 2429, 2440, 2448, 2467, 2471,
	10, 692, 2478, 2480, 87, 2034, 613, 2100, 234, 38, 224, 554, 103, 2311, 2130, 445, 190, 189, 444, 524, 569, 475,
	2198, 701, 559, 432, 3, 100, 223, 315, 41, 2300, 2330, 2285, 1793, 464, 551, 68, 11, 333, 39, 591, 2128, 531, 2304,
	2303, 538, 300, 35, 473, 1715, 2143, 99, 130, 593, 309, 1771, 567, 73, 137, 2132, 615, 546, 192, 188,
];

const providersDE = [
	9, 350, 2, 30, 304, 2137, 298, 337, 1853, 2035, 2037, 2038, 29, 677, 1796, 8, 175, 201, 262, 285, 286, 296, 334,
	582, 584, 597, 607, 678, 679, 680, 681, 686, 687, 693, 706, 707, 708, 1706, 1707, 1709, 1710, 1711, 1712, 1713,
	1741, 1757, 1788, 1805, 1806, 1891, 1892, 1968, 1989, 2063, 2065, 2134, 2141, 2173, 2227, 2229, 2231, 2233, 2243,
	2244, 2245, 2246, 2247, 2248, 2249, 2250, 2251, 2252, 2253, 2254, 2255, 2256, 2257, 2258, 2259, 2260, 2261, 2262,
	2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272, 2273, 2274, 2277, 2278, 2279, 2280, 2287, 2288, 2289,
	2290, 2291, 2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299, 2319, 2357, 2358, 2359, 2360, 2361, 2362, 283, 10, 1756,
	178, 1829, 133, 2478, 2412, 2211, 1958, 2220, 33, 533, 613, 2100, 415, 219, 1902, 234, 481, 1723, 1722, 341, 554,
	2125, 2131, 692, 190, 444, 524, 569, 475, 701, 542, 2138, 480, 559, 2209, 2103, 3, 100, 223, 315, 479, 2330, 421,
	2285, 2081, 349, 2206, 464, 310, 551, 20, 68, 562, 11, 28, 531, 538, 2077, 1945, 300, 522, 35, 344, 1954, 1715, 130,
	389, 498, 309, 1771, 1994, 2201, 567, 2136, 2207, 1993, 2076, 2281, 546, 1764, 192, 188, 537,
];

const providersFR = [
	119, 350, 381, 283, 2, 337, 2330, 1853, 677, 1875, 444, 239, 1796, 8, 201, 262, 296, 582, 588, 685, 688, 1732, 1733,
	1734, 1735, 1736, 1737, 1738, 1887, 1888, 1889, 1968, 2173, 2358, 2428, 10, 554, 2478, 2077, 415, 234, 59, 58, 345,
	2144, 324, 2140, 692, 190, 569, 475, 701, 542, 138, 559, 236, 3, 223, 315, 2285, 464, 310, 2145, 147, 551, 1899, 68,
	2139, 1967, 11, 61, 531, 2303, 538, 1945, 300, 2307, 35, 193, 513, 1715, 309, 1771, 550, 1754, 567, 2210, 1860,
	2286, 546, 192, 188,
];

const providersIT = [
	119, 350, 2, 1853, 39, 283, 696, 677, 337, 444, 1796, 8, 201, 262, 296, 582, 584, 607, 688, 689, 708, 1710, 1726,
	1727, 1728, 1729, 1730, 1894, 1895, 1896, 1897, 1968, 2108, 2141, 2243, 2275, 2358, 2388, 2389, 29, 2330, 10, 234,
	554, 2149, 2110, 692, 190, 524, 569, 475, 701, 559, 2478, 3, 100, 223, 315, 110, 2285, 464, 551, 359, 68, 11, 641,
	2111, 531, 538, 300, 222, 35, 1715, 2112, 309, 1771, 2109, 109, 567, 2113, 546, 188,
];

const providersES = [
	119, 350, 2241, 1717, 1773, 63, 2330, 2, 337, 677, 1854, 393, 1796, 8, 196, 201, 262, 296, 528, 607, 608, 684, 689,
	1739, 1740, 1741, 1742, 1743, 1890, 1968, 2141, 2243, 2275, 2358, 2393, 444, 283, 257, 1970, 2478, 1771, 2237, 2034,
	10, 234, 62, 554, 2127, 2124, 692, 190, 569, 475, 701, 64, 559, 3, 100, 223, 315, 2285, 2119, 464, 551, 1899, 68,
	456, 149, 11, 2121, 2122, 538, 300, 35, 541, 1875, 1715, 309, 1838, 567, 546, 188,
];

const sortingExpCountries = ['US', 'GB', 'DE', 'FR', 'IT', 'ES'] as const;

type sortingExpCountry = (typeof sortingExpCountries)[number];

export function isSortingExperimentCountry(country: string): country is sortingExpCountry {
	return sortingExpCountries.includes(country as sortingExpCountry);
}

export const sortingExpOrderedProvidersByCountry: Record<sortingExpCountry, number[]> = {
	US: providersUS,
	GB: providersGB,
	DE: providersDE,
	FR: providersFR,
	IT: providersIT,
	ES: providersES,
};
